The completed candidate submission for the position profile's questionnaire.

For Apply with SEEK candidate profiles, this is always `null`.

This field is redacted for a deleted candidate or job application.
